import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";

import axios from "axios";

const Notifications = ({ onClose, onCountChange }) => {
  const { userData } = useContext(UserContext);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("notifications"), Utils.apiHeaders())
      .then((res) => {
        setNotifications(res.data.notifications || []);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load notifications");
        setLoading(false);
      });
  }, []);

  const handleMarkRead = (id) => {
    // Optimistically remove from UI
    setNotifications((prev) => {
      const updated = prev.filter((n) => n.id !== id);
      if (onCountChange) onCountChange(updated.length);
      return updated;
    });
    axios
      .post(
        Utils.apiUrl("notifications/mark-read"),
        { notificationId: id },
        Utils.apiHeaders(),
      )
      .catch(() => {
        // Optionally, restore notification if API fails
      });
  };

  return (
    <div className="dashboard-section">
      <div className="section-title">
        <i className="fas fa-bell"></i>
        Notifications
      </div>
      <div className="space-y-3">
        {loading && <div className="text-gray-500">Loading...</div>}
        {error && <div className="text-red-500">{error}</div>}
        {!loading && !error && notifications.length === 0 && (
          <div className="text-gray-500">No notifications found.</div>
        )}
        {!loading &&
          !error &&
          notifications.map((n) => (
            <div
              key={n.id}
              className="notification-item p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-gray-100 transition"
              title="Click to mark as read"
              onClick={() => handleMarkRead(n.id)}
            >
              <div className="flex items-center space-x-4">
                <i className="fas fa-camera text-2xl text-gray-600"></i>
                <div>
                  <p
                    className="font-semibold text-gray-800"
                    dangerouslySetInnerHTML={{ __html: n.message }}
                  ></p>
                  <p className="text-sm text-gray-600">
                    {n.created_at
                      ? new Date(n.created_at).toLocaleString()
                      : ""}
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Notifications;
